(function(){
  function initSlider(slider){
    const setPos = (x)=>{
      const r = slider.getBoundingClientRect();
      let p = (x - r.left) / r.width;
      p = Math.max(0.02, Math.min(0.98, p));
      slider.style.setProperty('--pos', p);
    };

    let sx=0, sy=0, decided=false, dragging=false;

    const onDown = (e)=>{
      sx = e.clientX; sy = e.clientY; decided=false; dragging=false;

      const onMove = (ev)=>{
        if(!decided){
          const dx = Math.abs(ev.clientX - sx), dy = Math.abs(ev.clientY - sy);
          if(dx > 6 || dy > 6){
            decided = true;
            if(dx > dy){ dragging = true; try{ slider.setPointerCapture(ev.pointerId); }catch(_){} ev.preventDefault(); }
            else { cleanup(); return; }
          } else { return; }
        }
        if(dragging){ ev.preventDefault(); setPos(ev.clientX); }
      };

      const cleanup = ()=>{
        slider.removeEventListener('pointermove', onMove, {passive:false});
        slider.removeEventListener('pointerup', onUp);
        slider.removeEventListener('pointercancel', onUp);
        try{ slider.releasePointerCapture(ev.pointerId); }catch(_){}
      };
      const onUp = ()=> cleanup();

      slider.addEventListener('pointermove', onMove, {passive:false});
      slider.addEventListener('pointerup', onUp);
      slider.addEventListener('pointercancel', onUp);
    };

    slider.addEventListener('pointerdown', onDown, {passive:true});

    // init center
    const r = slider.getBoundingClientRect();
    setPos(r.left + r.width/2);
  }

  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.ba3 .slider').forEach(initSlider);
  });
})();
